
<!--Navbar-->
	<app-download-print-navbar class="p-0"></app-download-print-navbar>
<!--/.Navbar-->
<!--Main Content Area-->
<main class="bg-white" aria-label="Main Content" id="mainContent">
	<router-outlet></router-outlet>
</main>
